import { ExerciseSkill } from '@gmm/sdk-voodoo/shared';

export const ItemHeight = 40;
export const MiddleWidth = 80;

export const DEFAULT_ASSIGNMENT_SKILL_INSTANCES = 3;

export const getActiveSkills = (skills: ExerciseSkill[]): ExerciseSkill[] =>
  skills.filter(({ removed }) => !removed);
